import { useRouter } from 'next/router';
import { ArticleFeedFilters } from '~/components/Filters/FeedFilters/ArticleFeedFilters';
import { BountyFeedFilters } from '~/components/Filters/FeedFilters/BountyFeedFilters';
import { ComicFeedFilters } from '~/components/Filters/FeedFilters/ComicFeedFilters';
import { HubFeedFilters } from '~/components/Filters/FeedFilters/HubFeedFilters';

import { ImageFeedFilters } from '~/components/Filters/FeedFilters/ImageFeedFilters';
import { Model3DFeedFilters } from '~/components/Filters/FeedFilters/Model3DFeedFilters';
import { ModelFeedFilters } from '~/components/Filters/FeedFilters/ModelFeedFilters';
import { PostFeedFilters } from '~/components/Filters/FeedFilters/PostFeedFilters';
import { VideoFeedFilters } from '~/components/Filters/FeedFilters/VideoFeedFilters';
import { ToolFeedFilters } from '~/components/Filters/FeedFilters/ToolFeedFilters';
import { ManageHomepageButton } from '~/components/HomeBlocks/ManageHomepageButton';
import { NavTidyNotice } from '~/components/Alerts/NavTidyNotice';
import { HomeTabs } from '~/components/HomeContentToggle/HomeContentToggle';
import { ToolImageFeedFilters } from '~/components/Filters/FeedFilters/ToolImageFeedFilters';
import clsx from 'clsx';

const filterSections = [
  { pathname: '/', component: <ManageHomepageButton ml="auto" /> },
  { pathname: '/models', component: <ModelFeedFilters ml="auto" /> },
  { pathname: '/images', component: <ImageFeedFilters ml="auto" hideMediaTypes /> },
  { pathname: '/videos', component: <VideoFeedFilters ml="auto" /> },
  { pathname: '/3d-models', component: <Model3DFeedFilters ml="auto" /> },
  { pathname: '/posts', component: <PostFeedFilters ml="auto" /> },
  { pathname: '/articles', component: <ArticleFeedFilters ml="auto" /> },
  { pathname: '/bounties', component: <BountyFeedFilters ml="auto" /> },
  // /challenges renders its sort/filters inline with the Community Challenges section instead.
  { pathname: '/tools', component: <ToolFeedFilters ml="auto" /> },
  { pathname: '/tools/[slug]', component: <ToolImageFeedFilters ml="auto" /> },
  { pathname: '/comics', component: <ComicFeedFilters ml="auto" /> },
  // Matched on `router.pathname`, which is the ROUTE and not the URL, so this has
  // to carry the optional slug segment the hub route gained.
  { pathname: '/hubs/[id]/[[...slug]]', component: <HubFeedFilters ml="auto" /> },
];

export function SubNav2() {
  const router = useRouter();
  const section = filterSections.find((x) => x.pathname === router.pathname);

  return (
    <div
      className={clsx('flex items-center justify-between gap-2 px-2 py-1', {
        ['flex-wrap']: router.pathname !== '/',
      })}
    >
      <HomeTabs />
      <NavTidyNotice />
      {section?.component}
    </div>
  );
}
